import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import AddNewFundFactForm from "./addFundFact"
import ConfirmFundFact from "./confirmNewFundFact"
import { AddFundFact } from "./constants"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const AddNewFundFactModal = ({
  onClose,
  parent2Callback,
}: {
  onClose: () => void
  parent2Callback: () => void
}) => {
  const [step, setStep] = useState<AddFundFact>(AddFundFact.Form)
  const [data, setData] = useState<{
    clientFund: string
    assetClass: string
    subCategory: string | null
    percentage: string
    mainCategory: boolean
    error: string
  }>({
    clientFund: "",
    assetClass: "",
    subCategory: "",
    percentage: "",
    mainCategory: false,
    error: "",
  })

  return (
    <Overlay onClick={() => setStep(AddFundFact.Form)}>
      <ModalCard onClose={onClose}>
        {step === AddFundFact.Form && (
          <AddNewFundFactForm
            onSubmit={(
              clientFund,
              assetClass,
              subCategory,
              percentage,
              mainCategory
            ) => {
              setData((prev) => ({
                ...prev,
                clientFund,
                assetClass,
                subCategory,
                percentage,
                mainCategory,
              }))
              setStep(AddFundFact.Confirm)
            }}
          />
        )}
        {step === AddFundFact.Confirm && (
          <ConfirmFundFact
            clientFund={data.clientFund}
            assetClass={data.assetClass}
            subCategory={data.subCategory}
            percentage={data.percentage}
            mainCategory={data.mainCategory}
            onCancel={() => setStep(AddFundFact.Form)}
            onError={(error) => {
              setData((prev) => ({ ...prev, error }))
              setStep(AddFundFact.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === AddFundFact.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default AddNewFundFactModal
